<template>
  <card class="col-md-4" :title="'Sensor '+sensor.id" context="secondary">
    <div>
      <div
        :class="getBadge(sensor.state)"
        :title="$t('state.msgs.'+sensor.state)"
      >Status: {{$t('state.'+sensor.state)}}</div>
      <br>
      <div class="badge badge-primary">{{$t('message.value')}} {{sensor.value}} {{unit}}</div>
      <div
        class="badge badge-danger clickable"
        @click="showPopper($event)"
      >{{$t('message.limit')}} {{sensor.sensorConfiguration.act}} {{unit}}</div>
      <linear-gauge
        :value="sensor.value"
        :options="{height: 150,units:unit}"
        style="max-width: 100%"
      />
    </div>
  </card>
</template>

<script>
import { LinearGauge } from "../../utils/gauges/";
import { getBadge } from "../../sheriffUtils.js";
import Card from "../resources/Card";
export default {
  name: "TemperatureSensorView",
  props: {
    sensor: {
      required: true,
      type: Object
    },
    unit: {
      required: true
    }
  },
  methods: {
    showPopper(event) {
      this.$root.$emit("show-popper", event, this.sensor);
    },
    getBadge
  },
  components: {
    LinearGauge,
    Card
  }
};
</script>

<style>
</style>
